import { createContext, useContext, useEffect, useState } from 'react';
import { WebsocketContextData, WebsocketData, WebsocketProviderProps } from './types';
import { createCable } from '@anycable/web';
import { initialState } from './constants';

const WebsocketContext = createContext<WebsocketContextData | Record<string, never>>({});

const buildWsUrl = () => {
  const url = new URL(import.meta.env.VITE_API_WS as string);

  return url.toString();
};

export const WebsocketProvider = ({ children }: WebsocketProviderProps) => {
  const [state, setState] = useState<WebsocketData>(initialState);

  useEffect(() => {
    if (import.meta.env.VITE_DISABLE_WS === 'true') return;

    const ws = createCable(buildWsUrl());
    setState((prev) => ({ ...prev, ws }));

    return () => {
      ws.disconnect();
    };
  }, []);

  return (
    <WebsocketContext.Provider value={{ ...state, setState }}>{children}</WebsocketContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useWebsocketContext = () => useContext(WebsocketContext);
